<!-- Dashboard start -->
<!-- END: Left Aside -->

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="vendorForm">
  <!--MAIN-->
  <div class="m-content">
    <form
        [formGroup]="vendorForm"
        class="m-form m-form--fit m-form--label-align-right"
      >
      
    <!--begin::Portlet-->
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!vendorId">
              VENDOR DETAILS
            </h3>
            <h3 class="m-portlet__head-text" *ngIf="vendorId">
              EDIT VENDOR
            </h3>
          </div>
        </div>
      </div>

      <!--begin::Form-->
      
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Vendor Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="vendorName"
                  type="text"
                  id="name"
                  class="form-control m-input"
                  placeholder=""
                />
                <app-validation-display
                  *ngIf="vendorForm.controls.vendorName.errors?.required"
                  [control]="vendorForm.controls.vendorName"
                  errorMessage="Vendor name is required."
                ></app-validation-display>
                <app-validation-display
                  *ngIf="vendorForm.controls.vendorName.errors?.maxlength"
                  [control]="vendorForm.controls.vendorName"
                  errorMessage="Max character length is 30."
                ></app-validation-display>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Primary Contact:
              </label>
              <div class="col-lg-4">
                <select
                  formControlName="primaryContactId"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="userId"
                  name="userIdSelect"
                  (change)="selectUser($event.target.value)"
                >
                  <option selected value="0">-- Create New User --</option>
                  <option
                    *ngFor="let user of users"
                    [selected]="user.userId == vendorForm.controls.primaryContactId.value"
                    [value]="user.userId"    
                  >
                    {{ user.email }}
                  </option>
                </select>
                <span class="m-form__help">
                  Choose an email from this list if they are already the primary contact point for the new vendor. 
                  This contact must have the authority to use the vendor's bank account information. Otherwise, choose Create New User and complete the fields below. </span
                ><br />
                <span class="m-form__help">
                  E.g. A university that already uses the portal for light shows, but wants to start fundraising</span
                >
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Bank Statement Description:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="bankStatementDescription"
                  class="form-control m-input"
                  type="text"
                />
                <app-validation-display
                  *ngIf="vendorForm.controls.bankStatementDescription.errors?.required"
                  [control]="vendorForm.controls.bankStatementDescription"
                  errorMessage="Bank statement description is required."
                ></app-validation-display>
                <app-validation-display
                  *ngIf="vendorForm.controls.bankStatementDescription.errors?.minlength || vendorForm.controls.bankStatementDescription.errors?.maxlength"
                  [control]="vendorForm.controls.bankStatementDescription"
                  errorMessage="Must be between 5 and 10 characters in length."
                ></app-validation-display>
                <span class="m-form__help"><b>{{ vendorForm.controls.bankStatementDescription.value || 'Example' }}* (Campaign Name) </b></span>
                <br />
                <span class="m-form__help"> Above is an example of what a charge on a pledger's bank statement may look like. The second part of the description, after the asterisk, is dynamic
                  and will be the name of the campaign that the pledger is donating to. </span>
              </div>
            </div>

            <div class="form-group m-form__group row" *ngIf="!vendorId">
              <label class="col-lg-4 col-form-label">
              Is this vendor their own merchant?
              </label>
              <div class="col-lg-4">
              <label class="switch">
                  <input
                  formControlName="isMerchant"
                  type="checkbox"
                  />
                  <span class="slider round"></span>
              </label>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label"></label>
              <div  class="col-lg-3">
                <span class="m-form__help" style="font-weight: 800;">
                Enable Fundraising Products
                </span>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
              Cue5050:
              </label>
              <div class="col-lg-4">
              <label class="switch">
                  <input
                  formControlName="enableCue5050"
                  type="checkbox"
                  (change)="onChangeFundraisingProducts($event)"
                  />
                  <span class="slider round"></span>
              </label>
              <app-validation-display
                  [control]="vendorForm.controls.enableCue5050"
                  errorMessage="At least one fundraising product must be enabled."
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
              Pledge Per Win:
              </label>
              <div class="col-lg-4">
              <label class="switch">
                  <input
                  formControlName="enablePledgePerWin"
                  type="checkbox"
                  (change)="onChangeFundraisingProducts($event)"
                  />
                  <span class="slider round"></span>
              </label>
              <app-validation-display
                  [control]="vendorForm.controls.enablePledgePerWin"
                  errorMessage="At least one fundraising product must be enabled."
                ></app-validation-display>
              </div>
            </div>
            <div *ngIf="vendorForm.controls.enablePledgePerWin.value" class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
              CUE Audio Admin Fee Percentage:
              </label>
              <div class="col-lg-4">
                  <input
                    class="form-control m-input"
                    formControlName="pledgePerWinAdminPercent"
                    type="number"
                  />
              <app-validation-display
                  [control]="vendorForm.controls.pledgePerWinAdminPercent"
                  errorMessage="Value must be between 0 and 100."
                ></app-validation-display>
              </div>
            </div>

            <div *ngIf="vendorForm.controls.enablePledgePerWin.value" class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Stripe Fee Responsibility:
              </label>
              <div class="col-lg-4">
                <label class="switch">
                  <input
                    formControlName="stripeFeeResponsibility"
                    type="checkbox"
                  />
                  <span class="slider round"></span>
                </label>
                <app-validation-display
                  [control]="vendorForm.controls.stripeFeeResponsibility"
                  errorMessage=""
                ></app-validation-display>
                <span class="m-form__help">When enabled, CUE Audio takes a percentage and the cost of stripe fees from each transaction. This makes the vendor
                  responsible for the fees.
                </span>
                <br />
                <span class="m-form__help">When disabled, CUE Audio only takes a percentage of each transaction. This makes CUE Audio responsible for the fees.</span>
              </div>
            </div>

         <!--
            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                Show Address Fields:
                </label>
                <div class="col-lg-4">
                <label class="switch">
                    <input
                    formControlName="showAddressFields"
                    type="checkbox"
                    />
                    <span class="slider round"></span>
                </label>
              <br />
                <span class="m-form__help">
                  Optionally pre-fill the vendor's address, otherwise they will do it when they create their account</span
                >
                </div>
            </div> -->

          <div *ngIf="vendorForm.controls.showAddressFields.value"> 

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Address Line 1:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="addressLine1"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Address Line 2:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="addressLine2"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Building Name:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="buildingName"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    City:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="city"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    State or Province:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="stateProvince"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Country:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="country"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Postal Code:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="postalCode"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

          </div>

          </div>
        </div>

    </div>

    <div class="m-portlet" style="width: 100%">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!editMode">
              PRIMARY CONTACT INFORMATION
            </h3>
            <h3 class="m-portlet__head-text" *ngIf="editMode">
              EDIT PRIMARY CONTACT INFORMATION
            </h3>
          </div>
        </div>
      </div>
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">    

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                First Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="primaryContactFirstName"
                  type="text"
                  id="primaryContactFirstName"
                  class="form-control m-input"
                />
                <app-validation-display
                  *ngIf="vendorForm.controls.primaryContactFirstName.errors?.required"
                  [control]="vendorForm.controls.primaryContactFirstName"
                  errorMessage="First name is required."
                ></app-validation-display>
                <app-validation-display
                  *ngIf="vendorForm.controls.primaryContactFirstName.errors?.maxlength"
                  [control]="vendorForm.controls.primaryContactFirstName"
                  errorMessage="Max character length is 30."
                ></app-validation-display>
                <span class="m-form__help">
                  The first name of the person responsible for the vendor's account and bank information.</span
                >
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Last Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="primaryContactLastName"
                  type="text"
                  id="primaryContactLastName"
                  class="form-control m-input"
                />
                <app-validation-display
                  *ngIf="vendorForm.controls.primaryContactLastName.errors?.required"
                  [control]="vendorForm.controls.primaryContactLastName"
                  errorMessage="Last name is required."
                ></app-validation-display>
                <app-validation-display
                  *ngIf="vendorForm.controls.primaryContactLastName.errors?.maxlength"
                  [control]="vendorForm.controls.primaryContactLastName"
                  errorMessage="Max character length is 30."
                ></app-validation-display>
                <span class="m-form__help">
                  The last name of the person responsible for the vendor's account and bank information.</span
                >
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Email:
              </label>
              <div class="col-lg-4">
                <input
                  [requiredIf]="vendorForm.controls.primaryContactId.value < 1"
                  formControlName="email"
                  [ignoreWhiteSpace]
                  pattern='(?:[A-z0-9!#$%&amp;"*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&amp;"*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[A-z0-9-]*[A-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])'
                  type="text"
                  id="email"
                  class="form-control m-input"
                />
                <p 
                  style="color:red; padding: 0; font-family: 'Open Sans', sans-serif; font-size: 12px; font-weight: 300;" 
                  *ngIf="vendorForm.controls.active.value == true">
                    Cannot edit email addresses of Stripe verified accounts
                </p>
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                  vendorForm.controls.primaryContactId.value < 1 &&
                  !vendorForm.controls.email.valid &&
                    (vendorForm.controls.email.dirty ||
                      vendorForm.controls.email.touched)
                  "
                >
                  Please enter a valid email for this user
                </span>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Phone Number:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="phoneNumber"
                  type="text"
                  id="phonenumber"
                  pattern="^[\s.]*(\d{1,2}[\s.-]*)?\(?\d{3}\)?[\s.-]*\d{3}[\s.-]*\d{4}[\s.]*$"
                  maxlength="16"
                  class="form-control m-input"
                />
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    !vendorForm.controls.phoneNumber.valid &&
                    (vendorForm.controls.phoneNumber.dirty ||
                      vendorForm.controls.phoneNumber.touched)
                  "
                >
                  Please enter a valid phone number for this user
                </span>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Engine:
              </label>
              <div class="col-lg-4">
                <select
                  formControlName="engineId"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="userengine"
                  name="engineIdSelect"
                  (change)="selectEngine()"
                >
                  <option selected value="0">-- No Vendor Engine --</option>
                  <option
                    *ngFor="let engine of engines"
                    [selected]="engine.engineId == vendorForm.controls.engineId.value"
                    [ngValue]="engine.engineId"
                  >
                    {{ engine.applicationName }}
                  </option>
                </select>
                <span class="m-form__help">
                  Choose an engine for this Vendor Primary Contact if they are also a Live Events customer</span
                >
              </div>
            </div>

            <div *ngIf="this.vendorForm.controls.engineId.value > 0" class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Client Type:
              </label>
              <div class="col-lg-4">
                <select
                  [requiredIf]="vendorForm.controls.engineId.value > 0"
                  formControlName="primaryContactClientTypeId"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="clientSelect"
                  name="clientTypeSelect"
                >
                  <option disabled value="0">-- Choose a Client Type --</option>
                  <option
                    *ngFor="let client of clientTypes"
                    [selected]="client.clientTypeId == vendorForm.controls.primaryContactClientTypeId.value"
                    [ngValue]="client.clientTypeId"
                  >
                    {{ client.name }}
                  </option>
                </select>
                <span class="m-form__help">
                  Affects the price of Live Event products</span
                ><br />
                <span
                  class="m-form__help"
                  style="color:red;"
                  *ngIf="
                    vendorForm.controls.primaryContactId.value < 1 &&
                    !vendorForm.controls.primaryContactClientTypeId.valid &&
                    (vendorForm.controls.primaryContactClientTypeId.dirty ||
                      vendorForm.controls.primaryContactClientTypeId.touched)
                  "
                >
                  Please choose a client type for this user
                </span>
              </div>
            </div>
            
            <div *ngIf="vendorForm.controls.engineId.value > 0"> 
             <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this date range will dictate the period of time that this user can create services"
                  />
                  Subscription Period:
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      formControlName="enableSubscriptionPeriod"
                      id="enableSubscriptionPeriod"           
                      type="checkbox"
                      (change)="enableSubscription = !enableSubscription"
                    />
                    <span [ngStyle]="{'cursor': vendorForm.controls.primaryContactId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
                <div class="col-lg-4">
                  <span class="m-form__help" *ngIf="vendorForm.controls.primaryContactId.value > 0">
                    Cannot edit this user's settings here</span
                  >
                  <app-service-period
                    *ngIf="enableSubscription && vendorForm.controls.primaryContactId.value < 1"
                    [minDays]="30"
                    [showTooltip]="false"
                    formControlName="period"
                  ></app-service-period>
                </div>
              </div>
            

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, after the user uploads a custom track he will be able to program the torches for it"
                  />
                  Can User Program Lightshows
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="canProgramCustomTracks"
                      formControlName="canProgramCustomTracks"
                      type="checkbox"
                    />
                    <span [ngStyle]="{'cursor': vendorForm.controls.primaryContactId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this user will be able to create venues and add sections to their light shows"
                  />
                  Can User Edit Venues
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="canEditVenues"
                      formControlName="canEditVenues"
                      type="checkbox"
                    />
                    <span [ngStyle]="{'cursor': vendorForm.controls.primaryContactId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this user will be able to use the Global Sync feature"
                  />
                  Can User Start Global Sync
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="enableNetworkSync"
                      formControlName="enableNetworkSync"
                      type="checkbox"
                    />
                    <span [ngStyle]="{'cursor': vendorForm.controls.primaryContactId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
              </div>

            </div>



          </div>
          
        </div>
     
    </div>
  </form>

    <div class="form-group m-form__group row">
      <div class="col-lg-12">
        <button [debounceClick] [disabled]="loading" type="submit" (click)="save()" class="btn btn-primary">
          {{ vendorId ? "Update" : "Create" }}
        </button>
        <button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
          Cancel
        </button>
        <div *ngIf="validationErrors != ''">
          <span style="color:red">{{validationErrors}}</span>
        </div>
        
      </div>

    </div>
  </div>
</div>
